import { createNamedContext } from '@trinity/chat-components/utils/react';

export type TagGeneratingFilesContextValue = {
  generatingFileIds: Set<number>;
  addGeneratingFiles: (fileIds: number[], initialTimestamps?: Map<number, Date>) => void;
  removeGeneratingFile: (fileId: number) => void;
  isGenerating: (fileId: number) => boolean;
};

export const TagGeneratingFilesContext = createNamedContext<TagGeneratingFilesContextValue>(undefined, 'tag-generating-files-context');